import { useContext } from "react";
import SystemContext from "../../context/systemContext";
import browserStorage from "../storage";

const RoleManager = () => {
  const context = useContext(SystemContext);

  const hasAccess = (name: string) => {
    try {
      if (context?.roles?.isBoss && context?.roles["isBoss"]) {
        return true;
      } else {
        return name ? context?.roles[name] : true;
      }
    } catch (err) {
      return false;
    }
  };

  return [hasAccess];
};

export default RoleManager;
